const defaultValidator = () => {

    const form = $('.js-default-form-validation');

    if ( form.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validate_email", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("minlenght_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 10;
        });
        $.validator.addMethod("required_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 1;
        });

        form.validate({
            errorClass   : "input--error",
            validClass   : "input--success",
            errorElement : "span",
            rules : {
                formEmail: {
                    required: true,
                    email   : true,
                    validate_email: true
                },
                formPhone: {
                    required        : true,
                    required_phone  : true,
                    minlenght_phone : true
                },
                formAgreement: {
                    required: true
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function (element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))
                {
                    var currentObj = this;
                    var currentElement = element;
                    var delay = function () { currentObj.element(currentElement); };
                    setTimeout(delay, 0);
                }
            },
            errorPlacement: function(error, element) {
                error.appendTo($(element).parents('.js-input'));
            },
            submitHandler: function() {}
        });
    }
}